export default "__VITE_ASSET__84314481__"